<template>
  <div class="msgDetails">
    <div class="zMsgSearch">
      <span>{{ $t("common.dateRange") }}</span>
      <el-date-picker
        size="small"
        v-model="DataValue"
        type="daterange"
        :clearable="false"
        value-format="yyyy-MM-dd"
        :range-separator="$t('common.to')"
        :start-placeholder="$t('common.starDate')"
        :end-placeholder="$t('common.endDate')"
      >
      </el-date-picker>
      <el-button
        style="margin-left: 18px"
        @click="onSearch"
        size="small"
        type="primary"
        class="btn-chaxun"
        >{{ $t("common.btn.search") }}</el-button
      >
      <el-button @click="onClear" size="small" class="btn-del">{{
        $t("common.btn.cancel")
      }}</el-button>
      <el-button style="float: right" type="text" @click="downCar">{{
        $t("common.btn.download")
      }}</el-button>
    </div>
    <div class="zMsgTable">
      <i-table
        :list="list"
        :height="height"
        ref="carTable"
        @handleSelectionChange="handleSelectionChange"
        :options="option"
        :columns="columns"
        :operates="operates"
      ></i-table>
      <IPagination ref="page" @PageFun="changeSize"></IPagination>
    </div>
  </div>
</template>

<script>
import iTable from "../../../../../src/components/Table.vue";
import IPagination from "../../../../../src/components/pagination.vue";
import {
    domainName
} from "../../../../utility/index"
import moment from "moment";

export default {
  props: ["bindCar"],

  components: {
    iTable,
    IPagination,
  },
  data() {
    return {
      DataValue: [],
      height: "350",
      list: [],
      option: {
        stripe: true,
        border: true,
        loading: false,
        highlightCurrentRow: false,
        mutiSelect: false,
        serialNumber: true,
      },
      columns: [
        {
          prop: "driverNum",
          label: this.$t("common.driverNum"),
          align: "center",
          width: "160",
        },
        {
          prop: "driverName",
          label: this.$t("common.driverName"),
          align: "center",
        },
        {
          prop: "workTime",
          label: this.$t("DriverAnalysis.workHour"),
          align: "center",
        },
        {
          prop: "startTime",
          label: this.$t("DriverAnalysis.startTime"),
          align: "center",
          width: "160",
          // render: (h, params) => {
          //   return h('span', this.$formatTime(params.row.startTime))
          // }
        },
        {
          prop: "endTime",
          label: this.$t("DriverAnalysis.endTime"),
          align: "center",
          width: "160",
          // render: (h, params) => {
          //   return h('span', this.$formatTime(params.row.endTime))
          // }
        },
      ],
      operates: {
        width: 100,
        fixed: "right",
        list: [],
      },
      currentPage: 1,
      pageSize: 10,
      total: 1,
      bindValue: "",
    };
  },
  mounted() {
    this.getDate();
  },
  methods: {
    getDate() {
      const endTime = moment().format("YYYY-MM-DD");
      const startTime = moment().startOf("month").format("YYYY-MM-DD");
      this.DataValue = [startTime, endTime];
    },
    getCarRealTime() {
      const startTime = this.DataValue[0]
      const endTime = this.DataValue[1]
      let param = {
        carId: this.bindCar,
        startTime: startTime,
        endTime: endTime,
        pageNum: this.currentPage,
        pageSize: this.pageSize,
      };
      this.$store
        .dispatch("VehicleStatus/GET_CARREALTIMESTATUS", param)
        .then((res) => {
          if (res) {
            console.log(res);
            if (res.data.code == 200) {
              this.list = res.data.data.list;
              this.$refs.page.CommandTotal = res.data.data.total;
            }
          }
        })
        .catch((err) => {});
    },
    onSearch() {
      this.$refs.page.CommandCurrentPage = 1;
      this.currentPage = 1;
      this.getCarRealTime();
    },
    onClear() {
      this.getDate();
      this.getCarRealTime();
    },
    handleSelectionChange(val) {
      this.selected = val;
    },
    changeSize(item) {
      this.pageSize = item.pageSize;
      this.currentPage = item.pageNum;
      this.getCarRealTime();
    },
    downCar() {
      if (domainName) {
        let startTime = "";
        let endTime = "";
        if (this.DataValue && this.DataValue.length > 0) {
          startTime = this.DataValue[0];
          endTime = this.DataValue[1];
        }
        if (domainName.split(":")[0] !== "localhost") {
          let url = `https://${domainName}/v1/getExportExcel/exportCarWork?carId=${this.bindCar}&startTime=${startTime}&endTime=${endTime}`;
          location.href = url;
        } else {
          let host = "localhost:8080";
          let url = `https://${host}/v1/getExportExcel/exportCarWork?carId=${this.bindCar}&startTime=${startTime}&endTime=${endTime}`;
          location.href = url;
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import url("./index.less");
</style>
